import client from "./client";

export default {
  fullExportPowerpoint(params) {
    return client
      .withAuth()
      .get("womapi/api/powerpoint/export", params, {}, {}, "arraybuffer");
  },
  fullExport(params) {
    return client
      .withAuth()
      .get(
        "womapi/api/output/exportExcel",
        params,
        {},
        { Accept: "application/vnd.ms-excel" },
        {}
      );
  },
};
